const styledBy = (property, mapping) => props => mapping[props[property]];

export default styledBy;
